import { ECurrencies } from 'core/model/enums/currency.enum';
import { IProduct, IProductDetail } from 'core/model/interfaces/product.interface';
import { getSelectedUnitMeasure } from '../products.utils';
import { pushObjectDataLayer } from './gtm.events';

interface ITriggerSelectedProduct {
  product: IProduct;
  listName?: string;
  origin: string;
}

interface ITriggerDetailProduct {
  productDetail: IProductDetail;
  listName?: string;
}

export const triggerSelectedProduct = ({ product, listName = 'null', origin }: ITriggerSelectedProduct) => {
  const { price, presentation: presentacion, promoIndicators } = getSelectedUnitMeasure(product.unitMeasures);
  const finalProduct = {
    item_name: product.name,
    item_id: product.sku,
    price,
    item_brand: product.providerDisplayName,
    item_category: product.categoryName,
    item_category2: product.subcategoryName,
    item_list_id: listName,
    item_list_name: listName,
    procedencia: product.providerDisplayName,
    index: 1,
    quantity: 1,
    product_ean: product.eanCode,
    product_sku: product.sku,
    metadata: origin,
    dex: product.distributorName,
    aplica_descuento: promoIndicators.hasAnyDiscount,
    presentacion,
  };

  const data = {
    event: 'select_item',
    ecommerce: {
      currency: product?.currency.symbol || ECurrencies.PEN,
      items: [finalProduct],
    },
  };

  pushObjectDataLayer(data, triggerSelectedProduct.name);
};

export const triggerDetailProduct = ({ productDetail, listName = 'null' }: ITriggerDetailProduct) => {
  const { price, presentation: presentacion, promoIndicators } = getSelectedUnitMeasure(productDetail.unitMeasures);
  const finalProduct = {
    item_name: productDetail.name,
    item_id: productDetail.sku,
    price,
    item_brand: productDetail.providerDisplayName,
    item_category: productDetail.categoryName,
    item_category2: productDetail.subcategoryName,
    item_list_id: listName,
    item_list_name: listName,
    procedencia: productDetail.providerDisplayName,
    index: 1,
    quantity: 1,
    product_ean: productDetail.eanCode,
    product_sku: productDetail.sku,
    dex: productDetail.distributorName,
    aplica_descuento: promoIndicators.hasAnyDiscount,
    presentacion,
  };

  const data = {
    event: 'view_item',
    ecommerce: {
      currency: productDetail?.currency.symbol || ECurrencies.PEN,
      items: [finalProduct],
    },
  };

  pushObjectDataLayer(data, triggerDetailProduct.name);
};
